<template>
    <div class="col-md-3 col-6">
        <div
            class="shop_item shop_item-category"
            :class="item.display_type === 'icon' ? 'shop_item-category-emoji' : 'shop_item-category-image'"
            :style="{ backgroundImage: 'url(' + item.image + ')' }"
            @click="this.$router.push({
                name: 'ShopCategory',
                params: {
                    categoryId: item.id,
                },
                query: {
                    categoryName: item.name
                }
             })"
        >
            <div class="shop_item-category_icon" v-if="item.display_type === 'icon'">
                {{item.icon}}
            </div>
            <div class="shop_item-category_data">
                <div class="shop_item-category_title">
                    {{item.name}}
                </div>
                <div class="shop_item-category_price" v-if="item.price.value > 0">
                    от <currency-symbol :price="item.price"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import CurrencySymbol from "../CurrencySymbol";
    export default {
        name: "ShopCategoryItem",
        components: {CurrencySymbol},
        props: {
            item: {},
        },

        computed: {
        }
    }
</script>